<template>
  <div :class="device.desktop ? `cctv pa-6` : `cctv pa-2`">
    <div class="cctv-panel">
      <!-- Header panel: judul, pencarian & aksi -->
      <div class="cctv-panel-header">
        <v-icon
          small
          color="#60a5fa"
          class="mr-2"
        >mdi-cctv</v-icon>
        <span class="cctv-panel-title">DAFTAR KAMERA CCTV</span>
        <span class="cctv-panel-count">{{ records.length }} kamera</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Cari kamera..."
          single-line
          hide-details
          solo
          flat
          dense
          dark
          background-color="#0a1224"
          color="#60a5fa"
          class="cctv-search"
          style="max-width: 300px"
        ></v-text-field>
        <v-tooltip
          bottom
          color="#1e2c4f"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              dark
              v-on="on"
              v-show="page.actions.refresh"
              @click="fetchRecords"
              class="ml-2"
            >
              <v-icon color="#94a3b8">mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh Data</span>
        </v-tooltip>
        <v-btn
          depressed
          dark
          small
          class="cctv-btn-primary ml-2"
          v-show="page.actions.add"
          @click="openForm"
        >
          <v-icon
            left
            small
          >mdi-plus-circle-outline</v-icon>
          Tambah
        </v-btn>
      </div>

      <!-- Tabel desktop -->
      <v-data-table
        v-show="device.desktop"
        :headers="headers"
        :items="records"
        :items-per-page="table.options.itemsPerPage"
        :page.sync="table.options.page"
        class="cctv-table"
        dark
        :loading="loading.table"
        loading-text="Memuat data kamera..."
        :search="search"
        hide-default-footer
        @page-count="table.options.pageCount = $event"
        show-select
      >
        <v-progress-linear
          slot="progress"
          color="#3b82f6"
          height="2"
          indeterminate
        ></v-progress-linear>

        <template v-slot:item.name="{ value }">
          <div class="cctv-name">
            <v-icon
              small
              color="#60a5fa"
              class="mr-2"
            >mdi-cctv</v-icon>
            {{ value }}
          </div>
        </template>

        <template v-slot:item.public_access="{ value }">
          <v-chip
            :color="value.color"
            small
          >{{ value.text }}</v-chip>
        </template>

        <template v-slot:item.id="{ value }">
          <v-menu
            bottom
            origin="center center"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="#60a5fa"
                v-bind="attrs"
                v-on="on"
              >
                mdi-dots-vertical-circle-outline
              </v-icon>
            </template>

            <v-list
              dark
              color="#101b36"
            >
              <v-list-item
                @click="editRecord(value)"
                v-show="page.actions.edit"
              >
                <v-list-item-title>
                  <v-icon
                    color="orange"
                    class="mr-1"
                  >mdi-pencil-circle</v-icon>Ubah Data
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="postDeleteRecord(value)"
                v-show="page.actions.delete"
              >
                <v-list-item-title>
                  <v-icon
                    class="mr-1"
                    color="red"
                  >mdi-delete-circle</v-icon>Hapus Data
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>

      <!-- Daftar mobile -->
      <v-list
        subheader
        three-line
        v-show="device.mobile"
        dark
        color="#101b36"
      >
        <v-list-item-group
          multiple
          active-class=""
        >
          <v-list-item
            v-for="item in filterItems"
            :key="item.id"
          >
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox
                  :input-value="active"
                  color="#60a5fa"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.description }} </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-menu
                  bottom
                  origin="center center"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="#60a5fa"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-dots-vertical-circle-outline
                    </v-icon>
                  </template>

                  <v-list
                    dark
                    color="#101b36"
                  >
                    <v-divider v-if="page.delete || page.edit"></v-divider>
                    <v-list-item
                      @click="editRecord(item.id)"
                      v-show="page.actions.edit"
                    >
                      <v-list-item-title>
                        <v-icon
                          class="mr-1"
                          color="orange"
                        >mdi-pencil-circle</v-icon>
                        Ubah Data
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="postDeleteRecord(item.id)"
                      v-show="page.actions.delete"
                    >
                      <v-list-item-title>
                        <v-icon
                          class="mr-1"
                          color="red"
                        >mdi-delete-circle</v-icon>
                        Hapus Data
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>

    <!-- Dialog form tambah/ubah -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="form.add"
      :max-width="device.desktop ? `680px` : `100%`"
      persistent
      :fullscreen="device.mobile"
    >
      <v-card
        color="#101b36"
        dark
        class="cctv-dialog"
      >
        <div class="cctv-dialog-header">
          <v-icon
            small
            color="#60a5fa"
            class="mr-2"
          >{{ form.edit ? `mdi-pencil-circle-outline` : `mdi-plus-circle-outline` }}</v-icon>
          <span class="cctv-panel-title">{{ form.edit ? `UBAH DATA CCTV` : `TAMBAH DATA CCTV` }}</span>
        </div>
        <v-card-text class="cctv-dialog-body">
          <!-- Informasi kamera -->
          <div class="cctv-section-title">
            <v-icon
              small
              color="#93c5fd"
            >mdi-cctv</v-icon>
            Informasi Kamera
          </div>
          <v-row dense>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-select
                label="Area"
                outlined
                dense
                dark
                color="#60a5fa"
                background-color="#0a1224"
                persistent-hint
                hint="Wilayah/kecamatan lokasi kamera"
                v-model="record.area_uuid"
                :items="areas"
                prepend-inner-icon="mdi-map-marker-radius-outline"
              />
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-select
                label="Kategori Wilayah"
                outlined
                dense
                dark
                color="#60a5fa"
                background-color="#0a1224"
                persistent-hint
                hint="Kategori pengelompokan wilayah kamera"
                v-model="record.kategori_wilayah_uuid"
                :items="kategoriWilayahs"
                clearable
                prepend-inner-icon="mdi-map-legend"
              />
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-text-field
                outlined
                dark
                color="#60a5fa"
                background-color="#0a1224"
                label="Nama Kamera"
                placeholder="Contoh: Simpang Pemda 01"
                persistent-hint
                hint="Nama/identitas kamera CCTV"
                v-model="record.name"
                dense
                prepend-inner-icon="mdi-cctv"
              ></v-text-field>
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-text-field
                outlined
                dark
                color="#60a5fa"
                background-color="#0a1224"
                label="Identity"
                placeholder="Contoh: CAM-TGR-001"
                persistent-hint
                hint="Kode identitas perangkat kamera"
                v-model="record.identity"
                dense
                prepend-inner-icon="mdi-identifier"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Alamat"
                dark
                color="#60a5fa"
                background-color="#0a1224"
                v-model="record.address"
                outlined
                dense
                persistent-hint
                hint="Alamat lengkap titik pemasangan kamera"
                rows="2"
                prepend-inner-icon="mdi-map-marker-outline"
              ></v-textarea>
            </v-col>
          </v-row>

          <!-- Kontak penanggung jawab -->
          <div class="cctv-section-title">
            <v-icon
              small
              color="#93c5fd"
            >mdi-account-outline</v-icon>
            Kontak Penanggung Jawab
          </div>
          <v-row dense>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-text-field
                outlined
                dark
                color="#60a5fa"
                background-color="#0a1224"
                label="Kontak"
                placeholder="Nama yang bisa dihubungi"
                persistent-hint
                hint="Penanggung jawab kamera ini"
                v-model="record.contact_person"
                dense
                prepend-inner-icon="mdi-account-outline"
              ></v-text-field>
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-text-field
                outlined
                dark
                color="#60a5fa"
                background-color="#0a1224"
                label="Nomor Telpon (WA)"
                placeholder="08xxxxxxxxxx"
                persistent-hint
                hint="Nomor WhatsApp aktif"
                v-model="record.phone"
                dense
                prepend-inner-icon="mdi-whatsapp"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Perangkat & media -->
          <div class="cctv-section-title">
            <v-icon
              small
              color="#93c5fd"
            >mdi-video-wireless-outline</v-icon>
            Perangkat &amp; Media
          </div>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                outlined
                dark
                color="#60a5fa"
                background-color="#0a1224"
                label="URL RTSP"
                placeholder="rtsp://..."
                persistent-hint
                hint="Alamat streaming RTSP kamera"
                v-model="record.url"
                dense
                prepend-inner-icon="mdi-link-variant"
              ></v-text-field>
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-text-field
                label="File Photo"
                append-outer-icon="mdi-paperclip"
                v-model="filename"
                dark
                color="#60a5fa"
                background-color="#0a1224"
                outlined
                dense
                persistent-hint
                hint="Foto lokasi/tampilan kamera"
                @click:append-outer="uploadFile"
                prepend-inner-icon="mdi-image-outline"
              ></v-text-field>
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-select
                label="Kondisi"
                outlined
                dense
                dark
                color="#60a5fa"
                background-color="#0a1224"
                persistent-hint
                hint="Kondisi fisik kamera saat ini"
                v-model="record.status"
                :items="status"
                prepend-inner-icon="mdi-stethoscope"
              />
            </v-col>
          </v-row>

          <!-- Lokasi -->
          <div class="cctv-section-title">
            <v-icon
              small
              color="#93c5fd"
            >mdi-map-outline</v-icon>
            Titik Lokasi
            <span class="cctv-section-note">geser marker untuk menentukan koordinat</span>
          </div>
          <v-row dense>
            <v-col cols="12">
              <div class="cctv-map-wrap">
                <l-map
                  style="height: 280px; width: 100%; z-index: 0;"
                  :zoom="zoom"
                  :center="center"
                  @update:center="centerUpdated"
                >
                  <v-geosearch :options="geosearchOptions"></v-geosearch>
                  <l-tile-layer
                    :url="url"
                    :attribution="attribution"
                  ></l-tile-layer>
                  <l-marker
                    :key="marker.id"
                    :visible="marker.visible"
                    :draggable="marker.draggable"
                    :lat-lng.sync="marker.position"
                  >
                    <l-icon
                      iconSize=32
                      icon-url="/images/icon-marker-merah.png"
                    />
                    <l-popup :content="marker.tooltip" />
                    <l-tooltip :content="marker.tooltip" />
                  </l-marker>
                </l-map>
              </div>
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-text-field
                label="Garis Lintang"
                outlined
                dense
                dark
                color="#60a5fa"
                background-color="#0a1224"
                hide-details
                v-model="record.lat"
                prepend-inner-icon="mdi-latitude"
              ></v-text-field>
            </v-col>
            <v-col :cols="device.desktop ? 6 : 12">
              <v-text-field
                label="Garis Bujur"
                outlined
                dense
                dark
                color="#60a5fa"
                background-color="#0a1224"
                hide-details
                v-model="record.lng"
                prepend-inner-icon="mdi-longitude"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Akses -->
          <div class="cctv-access">
            <v-switch
              label="Dapat diakses oleh publik"
              color="#3b82f6"
              dark
              v-model="record.public_access"
              hide-details
              class="mt-0"
            ></v-switch>
            <div class="cctv-access-note">
              Jika aktif, kamera ini dapat dilihat masyarakat pada halaman depan
            </div>
          </div>
        </v-card-text>
        <v-divider class="cctv-dialog-divider"></v-divider>
        <v-card-actions class="justify-end pa-4">
          <v-btn
            text
            color="#94a3b8"
            @click="closeForm"
          >Batal</v-btn>
          <v-btn
            depressed
            dark
            class="cctv-btn-primary"
            v-show="!form.edit"
            @click="postAddNewRecord"
          >
            <v-icon
              left
              small
            >mdi-content-save-outline</v-icon>
            Tambah
          </v-btn>
          <v-btn
            depressed
            dark
            class="cctv-btn-primary"
            v-show="form.edit"
            @click="postUpdateRecord"
          >
            <v-icon
              left
              small
            >mdi-content-save-outline</v-icon>
            Ubah
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script >
import { mapActions, mapState } from "vuex";
import "animate.css";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LPopup,
  LTooltip,
} from "vue2-leaflet";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import VGeosearch from "vue2-leaflet-geosearch";
import "leaflet/dist/leaflet.css";

export default {
  name: "pos",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    VGeosearch,
    LIcon,
    LPopup,
    LTooltip,
  },
  data: () => ({
    num: 1,
    headers: [
      {
        text: "NAMA",
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: "IDENTITY",
        align: "start",
        sortable: false,
        value: "identity",
      },
      {
        text: "ALAMAT",
        value: "address",
        align: "start",
        sortable: false,
      },
      {
        text: "AREA",
        align: "start",
        sortable: false,
        value: "area",
      },
      {
        text: "KATEGORI WILAYAH",
        align: "start",
        sortable: false,
        value: "kategori_wilayah",
      },
      {
        text: "AKSES PUBLIK",
        align: "center",
        sortable: false,
        value: "public_access",
      },
      {
        text: "AKSI",
        value: "id",
        width: 100,
        sortable: false,
        align: "center",
      },
    ],
    search: null,
    path: null,
    filename: null,
    areas: [],
    kategoriWilayahs: [],
    status: [
      { text: "Baik", value: "baik" },
      { text: "Rusak", value: "rusak" },
    ],

    //map property
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a target="_blank" href="" style="color:brown">Pemerintahan Provinsi Banten</a>',
    zoom: 12,
    center: [-6.2204, 106.4675],

    geosearchOptions: {
      // Important part Here
      provider: new OpenStreetMapProvider(),
    },
    marker: {
      id: "m1",
      position: { lat: -6.2204, lng: 106.4675 },
      tooltip: "Geser untuk menentukan lokasi kamera",
      draggable: true,
      visible: true,
    },
  }),
  computed: {
    ...mapState([
      "page",
      "theme",
      "http",
      "device",
      "record",
      "records",
      "loading",
      "event",
      "snackbar",
      "form",
      "table",
    ]),
    filterItems() {
      if (this.search != null) {
        return this.records.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            item.nip.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        });
      } else {
        return this.records;
      }
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/superadmin/master-data/cctv",
      pagination: false,
      title: "MASTER DATA CCTV",
      subtitle: "Berikut Daftar Seluruh Data CCTV Yang Tersedia",
      showtable: true,
      breadcrumbs: [
        {
          text: "Data Master",
          disabled: true,
          href: "",
        },
        {
          text: "CCTV",
          disabled: false,
          href: "",
        },
      ],
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
        bulkdelete: false,
        print: false,
        export: false,
        help: false,
      },
    });
    this.fetchRecords();
    this.fetchAreas();
    this.fetchKategoriWilayahs();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "setPage",
      "fetchRecords",
      "postAddNew",
      "postEdit",
      "postUpdate",
      "postConfirmDelete",
      "assignFileBrowse",
      "setLoading",
      "setRecord",
      "setForm",
    ]),
    openForm: function () {
      this.setForm({
        add: true,
        edit: false,
      });
      this.setRecord({});
      this.filename = null;
      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 250);
    },
    closeForm: function () {
      this.setForm({
        add: false,
        edit: false,
      });
    },
    postAddNewRecord: function () {
      this.postAddNew(this.record).then((ok) => {
        if (ok) {
          this.closeForm();
          this.fetchRecords();
        }
      });
    },
    editRecord: function (val) {
      this.postEdit(val).then(() => {
        this.filename = this.record.foto;
        this.center = [this.record.lat, this.record.lng];
        this.marker.position = {
          lat: this.record.lat,
          lng: this.record.lng,
        };
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 250);
      });
      this.setForm({
        add: true,
        edit: true,
      });
    },
    postUpdateRecord: function () {
      this.postUpdate(this.record).then(() => {
        this.closeForm();
        this.fetchRecords();
      });
    },
    postDeleteRecord: function (val) {
      this.postConfirmDelete(val);
    },
    postDownload(val) {
      window.open(val, "__blank");
    },
    uploadFile: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png"],
        query: {
          doctype: "apps",
        },
        callback: (response) => {
          setTimeout(() => {
            this.filename = response.name;
            this.record.foto = response.name;
          }, 500);
        },
      });
    },
    centerUpdated(center) {
      this.center = center;
    },
    getUserPosition: async function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((pos) => {
          this.center = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          this.center = [pos.coords.latitude, pos.coords.longitude];
          this.marker.position = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };
        });
      }
    },
    fetchAreas: async function () {
      try {
        let { data } = await this.http.get("api/combo/area");
        this.areas = data;
      } catch (error) {}
    },
    fetchKategoriWilayahs: async function () {
      try {
        let { data } = await this.http.get("api/combo/kategori-wilayah");
        this.kategoriWilayahs = data;
      } catch (error) {}
    },
  },
  watch: {
    "marker.position": {
      handler() {
        this.record.lat = this.marker.position.lat;
        this.record.lng = this.marker.position.lng;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.cctv {
  min-height: 100%;
  background: #0a1224;
}

.cctv-panel {
  background: #101b36;
  border: 1px solid #1e2c4f;
  border-radius: 12px;
  overflow: hidden;
}

.cctv-panel-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #1e2c4f;
}

.cctv-panel-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #e2e8f0;
}

.cctv-panel-count {
  margin-left: 10px;
  padding: 2px 10px;
  border-radius: 999px;
  background: #0a1224;
  border: 1px solid #1e2c4f;
  font-size: 10px;
  font-weight: 600;
  color: #93c5fd;
}

.cctv-search >>> .v-input__slot {
  border: 1px solid #1e2c4f;
  border-radius: 8px;
}

.cctv-btn-primary {
  border-radius: 8px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #1d4ed8 0%, #0b3a79 100%) !important;
}

/* tabel gelap */
.cctv-table {
  background: #101b36 !important;
}

.cctv-table >>> thead th {
  background: #0d1730 !important;
  color: #93c5fd !important;
  font-size: 11px !important;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #1e2c4f !important;
}

.cctv-table >>> tbody td {
  color: #cbd5e1 !important;
  font-size: 13px !important;
  border-bottom: 1px solid #16224384 !important;
}

.cctv-table >>> tbody tr:hover {
  background: #16224384 !important;
}

.cctv-name {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #e2e8f0;
}

/* dialog */
.cctv-dialog {
  border: 1px solid #1e2c4f;
}

.cctv-dialog-header {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #1e2c4f;
  background: #0d1730;
}

.cctv-dialog-body {
  padding-top: 4px;
}

.cctv-dialog-divider {
  border-color: #1e2c4f !important;
}

.cctv-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #93c5fd;
  margin: 18px 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px dashed #1e2c4f;
}

.cctv-section-note {
  margin-left: auto;
  font-size: 10px;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  color: #64748b;
}

.cctv-map-wrap {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #1e2c4f;
  margin-bottom: 8px;
}

.cctv-access {
  margin-top: 18px;
  padding: 12px 16px;
  border-radius: 10px;
  background: #0a1224;
  border: 1px solid #1e2c4f;
}

.cctv-access-note {
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
}
</style>
